import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'spinner',
    template: `
	<div class="bounce1"></div>
	<div class="bounce2"></div>
	<div class="bounce3"></div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'spinner spinner-3',
    },
    standalone: false
})
export class Spinner {
}

@Component({
    selector: 'spinner-ball',
    template: `
	<div class="la-ball-clip-rotate-pulse {{size ? 'la-' + size : ''}}">
		<div></div>
		<div></div>
	</div>`,
    styleUrls: ['./spinner-ball.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'spinner',
    },
    standalone: false
})
export class SpinnerBall {
  @Input() size: 'sm' | '2x' | '3x' | null = 'sm';
}
